class s{}export{s as MdsConfig};
